import { useState, useEffect } from 'react'
import AdminForm from '../../components/admin/AdminForm'
import { motion } from 'framer-motion'

const API = import.meta.env.VITE_API_URL || '/api'
function getHeaders() { const t = localStorage.getItem('token'); return { 'Content-Type': 'application/json', Authorization: t ? `Bearer ${t}` : '' } }

const fields = [
  { name: 'email', label: 'Email', type: 'text' as const, required: true },
  { name: 'phone', label: 'Phone', type: 'text' as const },
  { name: 'whatsapp', label: 'WhatsApp URL', type: 'url' as const },
  { name: 'address', label: 'Address', type: 'text' as const },
  { name: 'socials', label: 'Socials (JSON)', type: 'json' as const },
]

export default function AdminContact() {
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [saved, setSaved] = useState(false)

  useEffect(() => {
    fetch(`${API}/contact`).then(r => r.json()).then(d => { setData(d); setLoading(false) })
  }, [])

  const handleSave = async (form: any) => {
    setSaving(true)
    const r = await fetch(`${API}/contact`, { method: 'PUT', headers: getHeaders(), body: JSON.stringify(form) })
    if (r.ok) { setSaved(true); setTimeout(() => setSaved(false), 3000) }
    setSaving(false)
  }

  if (loading) return <div className="text-center py-12 text-gray-400">Loading...</div>

  return (
    <div>
      <h1 className="text-2xl font-bold text-white mb-6">Contact Information</h1>
      {saved && <div className="mb-4 px-4 py-3 bg-green-500/10 border border-green-500/30 text-green-400 rounded-lg text-sm">Saved successfully!</div>}
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="bg-gray-900 border border-white/10 rounded-xl p-6 max-w-2xl">
        <AdminForm fields={fields} initial={data || { email: '', phone: '', whatsapp: '', address: '', socials: {} }} onSubmit={handleSave} onCancel={() => {}} loading={saving} />
      </motion.div>
    </div>
  )
}
